import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import { isVuexBooted, bootVuex } from './store';
import oidc from './vue-oidc-client';
import { APP_ERROR_KIND, resolveAppErrorKind, showAppError } from './js/appError';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes,
});

oidc.useRouter(router);

router.beforeEach((to, _from, next) => {
    const isSignInPage = to.name === 'signinwin-sso';
    if (isSignInPage) {
        return next();
    }

    const isAuthenticated = oidc.isAuthenticated;
    if (!isVuexBooted && isAuthenticated) {
        bootVuex()
            .then(() => next())
            .catch((error) => {
                if (error && error.isAuthRedirectStarted) {
                    // Уже уходим на SSO-редирект — навигацию не трогаем.
                    next(false);
                    return;
                }

                // Навигация ПРОПУСКАЕТСЯ, а не подменяется на страницу ошибки: адрес обязан
                // остаться тем, что открывал пользователь, иначе «Перезагрузить страницу»
                // повторяло бы саму заглушку. Приложение под оверлеем так и не отрисуется
                // (isVuexBooted остался false) — там будет спиннер, и это нормально: оверлей
                // его закрывает, а закрытие оверлея показывает, что загрузка не прошла.
                //
                // BOOT как запасной вид: справочники могли упасть с чем угодно, вплоть до
                // 422, и остаться без экрана вовсе пользователь не должен.
                showAppError(resolveAppErrorKind(error) || APP_ERROR_KIND.BOOT, { closable: false });
                next();
            });

        return;
    }

    next();
});

export const redirect = (path) => {
    router.push(path);
};

export default router;
